import React, { useState } from 'react'
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import FragenBeantworter from './FragenBeantworter';
import TarifFileUploader from './TarifFileUploader';
import EmpfehlungEditor from './EmpfehlungEditor';
import { Token, url } from '../../../../../Script/Session';

const steps = ['Leistungsübersicht Erstellen', 'Pflichtdateien Hochladen', 'Empfehlung Schreiben'];
function CreateFirstTarif({ setfirsttarif, data }) {
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});
  const [fragen, setfragen] = React.useState(new Map());
  const [bewertung, setbewertung] = React.useState(new Map());
  const [file, setfile] = React.useState(new Map());
  const [filedata, setfiledata] = React.useState(new Map());
  const [empfehlung, setempfehlung] = useState("");
  function post() {
    const formData = new FormData();
    let body = {};
    body.token = Token.get();
    body.targettarif = data.id;
    body.empfehlung = empfehlung;
    body.fragen = JSON.stringify(Object.fromEntries(fragen));
    body.bewertung = JSON.stringify(Array.from(bewertung.entries()).map(([key, value]) => [key, value?.id ?? null]));
    body.filedata = JSON.stringify(Object.fromEntries(filedata));
    console.log(JSON.stringify(body));
    formData.append("json", JSON.stringify(body));
    file.values().forEach(file => {
      formData.append("file", file); // gleicher Schlüssel "file"
    });

    fetch(url + "/api/tarife/create_tarif_stand", {
      method: "POST",
      body: formData,
    })
      .then(res => res.text()) // EINMAL aufrufen
      .then(text => {
        console.log(text);
        if (text === "OK") {
          setfirsttarif(false);
          window.location.reload();
        }
      })
      .catch(console.error);
  }


  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
        // find the first step that has been completed
        steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {

    setCompleted({
      ...completed,
      [activeStep]: true,
    });
    if (completedSteps() === totalSteps() - 1) {
      post();
    }
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  return (
    <Box sx={{ width: '98%', p: 2 }}>
      <Stepper nonLinear activeStep={activeStep}>
        {steps.map((label, index) => (
          <Step key={label} completed={completed[index]}>
            <StepButton color="inherit" onClick={handleStep(index)}>
              {label}
            </StepButton>
          </Step>
        ))}
      </Stepper>
      <div>
        {allStepsCompleted() ? (
          <React.Fragment>
            <Typography sx={{ mt: 2, mb: 1 }}>
              All steps completed - you&apos;re finished
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Box sx={{ flex: '1 1 auto' }} />
              <Button onClick={handleReset}>Reset</Button>
            </Box>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Typography sx={{ mt: 2, mb: 1, py: 1 }}>
              {
                activeStep === 0 && (
                  <FragenBeantworter data={data} afrage={fragen} setfragen={setfragen} bewertung={bewertung} setbewertung={setbewertung} />
                )
              }
              {
                activeStep === 1 && (
                  <TarifFileUploader pflichtdateien={data.dateien} setfile={setfile} files={file} dateiendata={filedata} setdateiendata={setfiledata} />
                )
              }
              {
                activeStep === 2 && (
                  <EmpfehlungEditor empfehlung={empfehlung} setempfehlung={setempfehlung} />
                )
              }
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Button
                color="inherit"
                disabled={activeStep === 0}
                onClick={handleBack}
                sx={{ mr: 1 }}
              >
                Zurück
              </Button>
              <Box sx={{ flex: '1 1 auto' }} />
              <Button onClick={handleNext} sx={{ mr: 1 }}>
                Weiter
              </Button>
              {activeStep !== steps.length &&
                (completed[activeStep] ? (
                  <Typography variant="caption" sx={{ display: 'inline-block' }}>
                    Schritt {activeStep + 1} Bereits abgeschlossen
                  </Typography>
                ) : (
                  <Button onClick={handleComplete}>
                    {completedSteps() === totalSteps() - 1
                      ? 'Speichern'
                      : 'Schritt abschliesen'}
                  </Button>
                ))}
            </Box>
          </React.Fragment>
        )}
      </div>
    </Box>
  );
}

export default CreateFirstTarif
